interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function ParadexLogoIcon(props: Props) {
  const { size = 32, className } = props;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#ParadexLogoIcon_clip_pat)">
        <path
          d="M28 0H4C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0Z"
          fill="#080822"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.787 11.7484L24 15.0989H21.9041L19.7868 11.8909H16.9136V10.2188H20.8033C21.5665 10.2188 22.185 9.64771 22.185 8.94416C22.185 8.59366 22.0313 8.27529 21.7806 8.04621C21.5313 7.81457 21.1861 7.67211 20.8033 7.67211H16.9136V6H20.8033C21.6875 6 22.4848 6.32936 23.0642 6.86326C23.2267 7.01311 23.3715 7.18039 23.4962 7.35877C23.8149 7.81703 24 8.36079 24 8.94416C24 9.40119 23.8867 9.83225 23.6851 10.2188C23.3097 10.9396 22.6246 11.4995 21.787 11.7484Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5831 7.35848C14.4584 7.17954 14.3136 7.01282 14.1506 6.86259C13.5719 6.32917 12.7738 6 11.8907 6H8V7.67221H11.8907C12.273 7.67221 12.618 7.81457 12.8673 8.04545C13.1177 8.2752 13.2722 8.59328 13.2722 8.94444C13.2722 9.648 12.6539 10.2178 11.8907 10.2178H8V15.0989H9.70321V11.8899H11.8907C13.1608 11.8899 14.2572 11.2074 14.7724 10.2178C14.9737 9.83244 15.0864 9.40062 15.0864 8.94444C15.0864 8.36022 14.9018 7.81684 14.5831 7.35848Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 16.9011H21.9141L19.9666 19.8639L18.019 16.9011H15.9331L18.9237 21.4506L15.9331 26H18.019L19.9666 23.0371L21.9141 26H24L21.0095 21.4506L24 16.9011Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9972 21.4506C14.9972 22.7077 14.4851 23.8448 13.6563 24.6673C12.8276 25.4909 11.6837 26 10.42 26H8V24.3254H10.42C12.0176 24.3254 13.3124 23.0385 13.3124 21.4506C13.3124 20.6566 12.9884 19.9381 12.465 19.418C11.9416 18.8977 11.2188 18.5757 10.42 18.5757H8V16.9011H10.42C12.9473 16.9011 14.9972 18.9374 14.9972 21.4506Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="ParadexLogoIcon_clip_pat">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
